import { render } from "./BoardMyTeam.vue?vue&type=template&id=24f94796&scoped=true"
import script from "./BoardMyTeam.vue?vue&type=script&lang=js"
export * from "./BoardMyTeam.vue?vue&type=script&lang=js"

import "./BoardMyTeam.vue?vue&type=style&index=0&id=24f94796&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f94796"]])

export default __exports__